// People on screen are identified by their permanent staff id (Oct 2026) --
// never by comparing names. A name is display text: two people may differ
// only in case, and a rename changes it.

/** The staff id of a person, a shift's holder, or a duty's holder; null if none. */
export const idOf = (person) => (person && typeof person === 'object' ? person.id ?? null : null);

/** Whether two people (or holders) are the same person: equal, present ids. */
export const samePerson = (a, b) => {
  const x = idOf(a);
  return x !== null && x === idOf(b);
};
